import React, { Component } from 'react';

import DownArrow from '../common/DownArror';
import { Link as ScrollLink } from 'react-scroll';

export class About extends Component {
	state = {
		paragraphs: [
			"Hi! I'm Baris, a front-end focused, full stack software engineer living in Seattle",
			"I was born in Izmir, Turkey and spent all my professional career in Istanbul, Turkey. Recently I moved to Seattle and I'm really enjoying it!",
			'I worked on different aspects of coding and used different languages and tools in my journey. After I discovered my passion for web development, I dedicated myself to learn more about the web and build more. ',
			'I like working with cutting-edge technologies and I always try to catch up with the fast-paced web development world.'
		]
	};
	render() {
		return (
			<div id="about" className="container" onMouseMove={this.onMouseMoveHandler} ref="container">
				<div className="full-height grid about__container">
					<div className="to-center">
						<h1>About</h1>
						<br />
						{this.state.paragraphs &&
							this.state.paragraphs.map((text, i) => (
								<React.Fragment key={i}>
									<p>{text}</p>
									<br />
								</React.Fragment>
							))}
					</div>
					<ScrollLink className="to-bottom" to="skills" smooth={true} duration={500}>
						<DownArrow />
					</ScrollLink>
				</div>
			</div>
		);
	}
}

export default About;



// WEBPACK FOOTER //
// ./src/components/containers/About.js